import { Box, Grid, Link, Skeleton, Typography } from '@mui/material'

import Carousel from 'react-elastic-carousel';
import React from 'react'
import { useRef } from 'react';
import { useSelector } from 'react-redux';

const WelcomBox = ({phone,tablet,slider}) => {
  const carouselRef = useRef()
  const isLoadingSlider = useSelector(state =>state.download.isLoadingSlider)
    return (
    <Grid container lg={12} xl={12} md={12} sm={12} xs={12}  padding={'20px'} bgcolor={"#424242"} borderRadius={phone ?'0 0 20px  20px' :'0 0 30px  30px'} position={"relative"}>
      <Box width="100%" display={"flex"} flexDirection={"column"}  gap={phone ? 2:10} position={"relative"}>
        <Box display={"flex"} justifyContent={"space-around"} flexWrap={"wrap"} p="5px" gap={2}>
                {phone ? 
                    <Box component={"div"} data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-duration="2000" display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"} width="300px" m="auto" gap={5}>
                        <Box component={"div"} display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"} gap={2} >
                            <Typography variant='h4' component={"b"} style={{color:'#fff'}}  fontWeight={700} lineHeight={1.3} fontSize={'36px'} width={"200px"} textAlign={"center"}   data-aos="fade-up" data-aos-anchor-placement="top-bottom"> به مجموعه جان اسنک خوش آمدید  </Typography>
                            <Typography color="#fff" data-aos="fade-up" data-aos-anchor-placement="top-bottom"  > برترین برند کیفی اسنک در ایران  </Typography>
                        </Box>
                        <Link href='tel:1507'>
                            <img src="/images/tel.png" alt="جان اسنک" width={"103px"} height={"40px"}    data-aos="fade-up" data-aos-anchor-placement="top-bottom"/>
                        </Link>
                    
                        <Box display={"flex"}   data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="5000" justifyContent={"center"} position={"relative"} width={"100px"}  alignItems={"center"} mr="7%" mb="5%">
                            <Link  ml="100%" position={"absolute"} borderRadius={"50%"} bgcolor={"#000"} height={'30px'}  width={"30px"} display={"flex"} alignItems={"center"} justifyContent={"center"} target='_blank' href="https://www.aparat.com/jan_snak"  data-aos="fade-up" data-aos-anchor-placement="top-bottom" >
                                <img src="/images/aparat.png" alt="" width="21px" height={"21px"} />

                            </Link>
                            <Link  ml="65%" position={"absolute"} borderRadius={"50%"} bgcolor={"#000"} height={'30px'}  width={"30px"} display={"flex"} alignItems={"center"} justifyContent={"center"} target='_blank' href="https://t.me/jansnakbot"  data-aos="fade-up" data-aos-anchor-placement="top-bottom" >
                                <img src="/images/telegram.png" alt="" width="21px" height={"21px"} />

                            </Link>
                            <Link  ml="25%" position={"absolute"} borderRadius={"50%"} bgcolor={"#000"} height={'30px'}  width={"30px"} display={"flex"} alignItems={"center"} justifyContent={"center"} target='_blank' href="#"  data-aos="fade-up" data-aos-anchor-placement="top-bottom" >
                                <img src="/images/facebook.png" alt="" width="21px" height={"21px"} />

                            </Link>
                            <Link  mr="20%" position={"absolute"} borderRadius={"50%"} bgcolor={"#000"} height={'30px'}  width={"30px"} display={"flex"} alignItems={"center"} justifyContent={"center"} target='_blank' href="https://instagram.com/jan_snak"  data-aos="fade-up" data-aos-anchor-placement="top-bottom">
                                <img src="/images/instagram.png" alt=""width="21px" height={"21px"} />

                            </Link>
                        {/* <Box position={"absolute"}  mr="60%" position={"absolute"} borderRadius={"50%"} bgcolor={"#000"} height={'30px'}  width={"30px"} display={"flex"} alignItems={"center"} justifyContent={"center"}> */}
                        <Link   mr="60%" position={"absolute"} borderRadius={"50%"} bgcolor={"#000"} height={'30px'}  width={"30px"} display={"flex"} alignItems={"center"} justifyContent={"center"} target='_blank' href="https://www.linkedin.com/company/jansnak"  data-aos="fade-up" data-aos-anchor-placement="top-bottom">
                            <img src="/images/linkedin.png" alt="" width="21px" height={"21px"}/>

                        </Link>

                        {/* </Box> */}
                        </Box>
                    </Box>
                
                :
                    <Grid container display={"flex"} justifyContent={"space-around"} alignItems={"center"}>
                        <Grid item lg={5} xl={5} md={5} display={"flex"} flexDirection={"column"} gap={2}>
                            <Box display={"flex"} justifyContent={"space-between"}  >
                                <h1  data-aos="fade-up" style={{color:'#fff'}} data-aos-anchor-placement="top-bottom"  data-aos-delay="100"> به مجموعه </h1>
                                <Link href='tel:1507'  data-aos="fade-up" data-aos-anchor-placement="top-bottom" >
                                    <img src="/images/tel.png" alt="جان اسنک" width={"80%"}  data-aos-delay="300" />

                                </Link>
                            </Box>
                            <h1 style={{color:'#fff'}}  data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-delay="200"> جان اسنک خوش آمدید  </h1>
                        </Grid>
                        <Grid item lg={5} xl={5} display={"flex"} gap={3}   >
                            {!phone &&<h5 style={{color:'#fff'}} data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="500"> برترین برند کیفی اسنک در ایران </h5>} 
                            <Box display={"flex"} justifyContent={"space-between"}  >
                                <Box display={"flex"} justifyContent={"space-between"} position={"relative"} width={"100px"} >
                                    <Link target='_blank'  href="https://www.aparat.com/jan_snak" data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="1000" position={"absolute"} ml="105%"  borderRadius={"50%"} bgcolor={"#000"} p="5px" display={"flex"} alignItems={"center"} justifyContent={"center"}>
                                        <img src="/images/aparat.png" alt="" width={"21px"}  />
                                    </Link>
                                    <Link target='_blank'  ml="83%"  href="https://t.me/jansnakbot" position={"absolute"} data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="900"  borderRadius={"50%"} bgcolor={"#000"} p="7px" display={"flex"} alignItems={"center"} justifyContent={"center"}>
                                        <img src="/images/telegram.png" alt="" width={"21px"} />
                                    </Link>
                                    <Link position={"absolute"}  ml="63%"   borderRadius={"50%"} bgcolor={"#000"} p="5px" display={"flex"} alignItems={"center"} justifyContent={"center"}  data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="800" >
                                        <img src="/images/facebook.png" alt="" width={"21px"}/>
                                    </Link>
                                    <Link target='_blank'  ml="40%" href="https://instagram.com/jan_snak" data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="700" position={"absolute"}   borderRadius={"50%"} bgcolor={"#000"} p="5px" display={"flex"} alignItems={"center"} justifyContent={"center"}>
                                        <img src="/images/instagram.png" alt="" width={"21px"}  />
                                    </Link>
                                    <Link target='_blank'ml="20%"  href="https://www.linkedin.com/company/jansnak" position={"absolute"}  borderRadius={"50%"} bgcolor={"#000"} p="5px" display={"flex"} alignItems={"center"} justifyContent={"center"} data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="600">
                                        <img src="/images/linkedin.png" alt="" width={"21px"} />
                                    </Link>

                                </Box>
                            </Box>

                        </Grid>
                    </Grid>
                }
            </Box>
          {/* {phone ? */}
          
        </Box>
          <Box display={"flex"} alignItems={"center"} justifyContent={"center"} position={"relative"} width={"100%"} height={phone ?"90px" :"300px"} mt={!phone?"12%":'20%'}>
            {isLoadingSlider ? 

                <Skeleton variant="rectangular" width="100%" sx={{ bgcolor: 'grey.300',borderRadius:'50px',height:phone ?"100px" :"500px"}}/>
                    
                
            :
            <Carousel ref={carouselRef} autoPlaySpeed={4000} isRTL={true} pagination={false} className='slider'  showArrows={false}  enableAutoPlay onNextEnd={
            (currentItem, nextItem) => {
          
              if(nextItem === slider?.length -1) {
                setTimeout(() => {
                  carouselRef.current.goTo(0);
                }, 4000)
              }
            }
          }
          >
            

            
              {slider?.map((item,index) => 
                <Grid index={1} item lg={12} xl={12} md={12} sm={12} xs={12}  height={'100%'}  width="100%" mt={phone&&'15%'}  >
                  <Link href={item.link} target='_blank'>
                    <img src={item.img} alt={item.title} height={"100%"} width={"100%"} style={{borderRadius:'18px',cursor:'pointer'}} />
                  </Link>
                  
                </Grid>
              )}
          
        

          </Carousel>}
          </Box>
        
    </Grid>
  )
}

export default WelcomBox